import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { TimePicker } from 'antd';
import { InputGroup } from 'react-bootstrap';
import InfoBar from '../InfoBars';
import DisabledCalenderIcon from '../../../assets/svg/DisabledCalender.svg'
import Vectoricon from '../../../assets/svg/Vector.svg'
import './TimePicker.css'

interface TimePickerProps {
  minTime: string;
  maxTime: string;
  value?: any;
  className?: string;
  labelName?: string;
  required?: boolean;
  isDisabled: boolean;
  inputType?: 'general' | 'entered' | 'error' | 'success' | 'disabled';
  errorMessage: string;
  placeholder: string;
  onChange: (event: any) => void;
  onClick?: () => void;
  /**
    * 'isCurrentTime': Boolean flag to update maxTime to current time dynamically
  */
  isCurrentTime?:boolean;
  timeFormat?:any;
}

const CommonTimePicker = ({ minTime, maxTime, value, className, labelName, required, isDisabled, inputType, errorMessage, placeholder, onClick, onChange, isCurrentTime, timeFormat}: TimePickerProps) => {
  const [maximumTime, setMaximumTime] = useState<any>(maxTime);
  const timeOutRef = useRef<any>(null);
  const intervalRef = useRef<any>(null);

  const handleChange = (e: any) => {
    onChange(e);
  }

  useEffect(()=> {
    if(isCurrentTime) {
      updateMaxTime();
    } else {
      setMaximumTime(maxTime);
    }

    return () => clearIntervals();
  },[maxTime, isCurrentTime]);

  const updateTime = () => setMaximumTime(dayjs().format('HH:mm'));

  const updateMaxTime = () => {

    updateTime();
    const initialDelays = (60 - dayjs().second()) * 1000;
    timeOutRef.current = setTimeout(() => {
      updateTime();
      intervalRef.current = setInterval(updateTime, 60000);
    }, initialDelays);
  }

  const clearIntervals = () => {
    if(timeOutRef.current) {
      clearTimeout(timeOutRef.current);
      timeOutRef.current = null;
    }
    if(intervalRef.current) {
      clearTimeout(intervalRef.current);
      intervalRef.current = null;
    }
  }

  const disabledTime = () => ({
    disabledHours: () =>
      Array.from({ length: 24 }, (_, hour) => hour).filter(
        (hour: number) =>
          (minTime && hour < dayjs(minTime, 'HH:mm').hour()) ||
          (maximumTime && hour > dayjs(maximumTime, 'HH:mm').hour()),
      ),
    disabledMinutes: (selectedHour: any) => {
      let minutes: number[] = [];
      if (minTime && selectedHour === dayjs(minTime, 'HH:mm').hour()) {
        minutes = Array.from(
          { length: dayjs(minTime, 'HH:mm').minute() },
          (_, minute) => minute,
        );
      }
      if (maximumTime && selectedHour === dayjs(maximumTime, 'HH:mm').hour()) {
        minutes = [
          ...minutes,
          ...Array.from({ length: 60 }, (_, minute) => minute).slice(
            dayjs(maximumTime, 'HH:mm').minute() + 1,
          ),
        ];
      }
      return minutes;
    },
  });

  return (
    <div className={`input-field-container  ${className}`}>
    {labelName && (
      <label
        className={`label-name-from-parent ${required && 'yes'} ${isDisabled}`}
      >
        {labelName}
      </label>
    )}
    <InputGroup
      className={` input-field-group input-field-group-${inputType}`}
      onClick={()=>{
        if(onClick){
          onClick();
        }
      }}
    >
    <TimePicker format={timeFormat ? timeFormat : 'hh:mm A'} value={value? dayjs(value) : undefined} disabledTime={disabledTime} onChange={handleChange} placeholder={timeFormat ? timeFormat : 'hh:mm A'} suffixIcon={isDisabled ? <DisabledCalenderIcon /> : <Vectoricon />} disabled={isDisabled} changeOnScroll={false} />
    </InputGroup>
    <div className="input_field_infoBars">
      {inputType === 'success' ? (
        <InfoBar
          variant="success"
          message={errorMessage?errorMessage:'Success'}
          className="input_field_class"
        />
      ) : (
        ''
      )}
      {inputType === 'error' ? (
        <InfoBar
          variant="danger"
          message={errorMessage?errorMessage:''}
          className="input_field_class"
        />
      ) : (
        ''
      )}
    </div>
  </div>
  );
};

export default CommonTimePicker;